import {useMemo} from "react";

import {computed} from "mobx";

/** Hook for using a MobX computed value. Optionally takes a dependency array for compatibility with React props. */
export function useComputed<T>(computation: () => T, deps: readonly unknown[] = []): T {
    //eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => computed(computation), deps).get();
}
